import { useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';
import { Loading } from '@/components/shared/Loading';


interface IPesquisadorVisitanteConvidado extends IUsuario {
}

// const tipoDocenteDescricoes = [
//     'Docente Pleno - Pós-graduação', 0
//     'Docente Participante', 1
//     'PPPD - Pós-graduação', 2
//     'PAD', 3
//     'PED', 4
//     'Pesquisador Colaborador', 5
//     'Pesquisador Visitante Convidado', 6
//     'Professor Colaborador', 7
//     'Visitante' 8
// ];

const PesquisadorVisitanteConvidado = () => {
    const [pesquisadoresVisitantesConvidados, setPesquisadoresVisitantesConvidados] = useState<IPesquisadorVisitanteConvidado[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getPesquisadorVisitanteConvidado = async () => {
            setIsLoading(true);
            const url = 'user/register/TipoDocentes/6';

            await api.get(url)
                .then(response => {
                    setPesquisadoresVisitantesConvidados(response.data)
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));
        }

        getPesquisadorVisitanteConvidado();

    }, [])

    return (
        <>
            <h1>Pesquisador Vistante Convidado</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <div>
                    {pesquisadoresVisitantesConvidados.map(pesquisador => (
                        <DocenteItem key={pesquisador._id} data={pesquisador} />
                    ))}
                </div>
            )}
        </>
    );
}

export { PesquisadorVisitanteConvidado }